module.exports = __webpack_public_path__ + "static/media/btn-appdl-android.d1e6902b.png";